import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"home\"><defs><style>#home .cls-1{fill:none}</style></defs><title>资源 5</title><g id=\"home_图层_2\" data-name=\"图层 2\"><g id=\"home_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path d=\"M10.57 2a2.3 2.3 0 0 1 2.67-.14l.19.14 7.65 6.07a2.31 2.31 0 0 1 .85 1.57V20.2a2.29 2.29 0 0 1-2.07 2.29H4.35a2.29 2.29 0 0 1-2.28-2.08V9.87a2.33 2.33 0 0 1 .69-1.65l.17-.15zm1.9 1.2a.74.74 0 0 0-.82-.08l-.13.08-7.65 6.07a.78.78 0 0 0-.27.46V20.2a.78.78 0 0 0 .63.76h15.42a.76.76 0 0 0 .75-.63V9.87a.77.77 0 0 0-.18-.5l-.1-.1zm-1.38 3.9a1.5 1.5 0 0 1 1.64-.1l.17.11 4.59 3.36a1.54 1.54 0 0 1 .62 1v5.63a1.53 1.53 0 0 1-1.35 1.52H7.41a1.53 1.53 0 0 1-1.52-1.35v-5.58a1.55 1.55 0 0 1 .49-1.12l.14-.11z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/home.svg
// module id = J8GQ
// module chunks = 6